import ApiResponse from './api/Response';
import { generateFormData } from './forms';
import { generateQueryString } from './uri';

export default {
    get(path, params = null, ...args) {
        return this.fetch('GET', path, params, args)
    },

    post(path, params = null, ...args) {
        return this.fetch('POST', path, params, args);
    },

    delete(path, params = null, ...args) {
        return this.fetch('DELETE', path, params, args);
    },

    fetch(method, path, params = null, args = []) {
        return new Promise((resolve, reject) => {
            this.resolveFetch({ method, path, params, args }, resolve, reject);
        });
    },

    download(path, params = null, ...args) {
        return new Promise((resolve, reject) => {
            this.resolveFetch({ 
                method: 'GET',
                path: path,
                params: params,
                args: {
                    headers: { Accept: '*/*' }
                }
            }, apiResponse => {
                if(apiResponse.data && typeof apiResponse.data == 'object' && 'size' in apiResponse.data) {
                    resolve(URL.createObjectURL(apiResponse.data));
                } else {
                    reject(apiResponse);
                }
            }, reject);
        });
    },

    resolveFetch({ method, path, params, args }, resolve, reject) {
        args = Array.isArray(args) ? Object.assign({}, args) : args;

        let options = {
            method: method,
            headers: this.getHeaders('headers' in args ? args.headers: {})
        };

        if(params && method == 'POST') {
            options.body = generateFormData(params);
            params = null;
        }

        let apiResponse = null;
        let url = this.getUrl(path, params);

        return fetch(url, options).then(response => {
            apiResponse = new ApiResponse(response); 

            if(apiResponse.contentType == 'json') {
                return response.json();
            } else if(apiResponse.contentTypeGroup == 'text') {
                return response.text();
            } else {
                return response.blob();
            }
        }, networkError => {
            apiResponse = new ApiResponse(); 
            apiResponse.setNetworkError(networkError);

            reject(apiResponse);
        }).then(result => {
            apiResponse.setData(result);

            if(apiResponse.success) {
                resolve(apiResponse);
            } else {
                reject(apiResponse);
            }
        }, error => {
            console.error('get api response data error');
            console.error(error);
        });
    },

    getUrl(path, params = null) {
        path = '/api/' + path;

        if(params) {
            path += (path.indexOf('?') != -1 ? '&' : '?') + generateQueryString(params);
        }

        return path;
    },

    getHeaders(headers = {}) {
        if(!'Accept' in headers) {
            headers.Accept = 'application/json';
        }
        
        return headers;
    }
}